import { useFormikContext } from "formik";
import { CvssService } from "./CvssService";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";


export const onScoreRender = (formikParams: any) => {
    const form = useFormikContext<any>();
    const { t } = useTranslation();
    const { bgClass, baseScore, rating } = CvssService.calculate(t, form.values); 
    const matches = useMediaQuery({query: '(min-width: 768px)' });
    return <div {...formikParams} id="bgClass" style={matches ? {
        position: "absolute",
        top: "122px",
        right: "5px",
        width: "242px",
        textAlign: "center",
        borderRadius: "6px"
    } : { borderRadius: "6px", textAlign: "center" }} className={`alert text-center ${bgClass}`}>
        <h3 style={{ fontSize: "22px", margin: "0px" }}>
            {t("Labels.RatingTitle", "CVSS v3 score")}
        </h3>
        <h3 style={{ fontSize: "22px", margin: "0px" }}>{baseScore}</h3>
        <h3 style={{ fontSize: "22px", margin: "0px" }}>{rating}</h3>
    </div>
}